import { Link } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";
import { formatDate } from "../../utils/dateAndTime";

export const FeaturedFightCard = ({ fight }) => {
  const { user } = useAuthStore();

  if (!fight) return null;

  const {
    FightID,
    date,
    fightType,
    Player1Details,
    Player2Details,
    GameDetails,
    LeagueDetails,
    SeasonDetails,
    stats,
  } = fight;

  const formattedDate = date ? formatDate(date) : "";

  const homeTeam = GameDetails?.HomeTeamDetails;
  const awayTeam = GameDetails?.AwayTeamDetails;

  return (
    <Link
      to={`/fight/${FightID}`}
      className="block bg-flyers-charcoal border border-flyers-dark-gray rounded-lg p-6 hover:border-flyers-orange hover:shadow-orange-glow transition-all duration-200"
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-flyers-orange text-sm font-heading font-bold uppercase tracking-wider">
          Featured Fight
        </span>
        <span className="text-flyers-mid-gray text-sm">{formattedDate}</span>
      </div>

      <div className="flex items-center justify-center gap-4 my-6">
        <div className="text-right flex-1">
          <p className="text-white text-xl font-bold">
            {Player1Details?.firstName} {Player1Details?.lastName}
          </p>
          {homeTeam && (
            <p className="text-flyers-mid-gray text-sm">
              {homeTeam.city} {homeTeam.name}
            </p>
          )}
        </div>

        <span className="text-flyers-orange text-2xl font-heading font-black px-4">VS</span>

        <div className="text-left flex-1">
          <p className="text-white text-xl font-bold">
            {Player2Details?.firstName} {Player2Details?.lastName}
          </p>
          {awayTeam && (
            <p className="text-flyers-mid-gray text-sm">
              {awayTeam.city} {awayTeam.name}
            </p>
          )}
        </div>
      </div>

      <div className="flex items-center justify-between text-sm">
        <div className="flex gap-4 text-flyers-mid-gray">
          {fightType && <span>{fightType}</span>}
          {LeagueDetails && <span>{LeagueDetails.name}</span>}
          {SeasonDetails && <span>{SeasonDetails.season}</span>}
        </div>

        <div className="flex gap-4 text-flyers-mid-gray">
          {user ? (
            <>
              <span>
                {stats?.totalVotes || 0} vote{stats?.totalVotes !== 1 ? "s" : ""}
              </span>
              <span>
                {stats?.totalComments || 0} comment{stats?.totalComments !== 1 ? "s" : ""}
              </span>
            </>
          ) : (
            <span className="text-flyers-orange/70 italic">
              <Link to="/login" className="hover:text-flyers-orange underline">
                Log in
              </Link>{" "}
              to vote on fights
            </span>
          )}
        </div>
      </div>
    </Link>
  );
};
